import template from'lodash-es/template';/*
 * Renders a template using lodash `_.template()`, note that importing html requires
 * a `raw-loader` setup like this:
 *
 * {
 *   test: /\.tpl.html$/,
 *   loader: 'raw-loader'
 * }
 *
 * Example:
 * import renderTemplate from 'lib/template';
 * import someTemplate from 'views/someTemplate.tpl.html';
 *
 * const html = renderTemplate(someTemplate, context);
 */export default(function(tpl,params){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var compiled=template(tpl,options);return compiled(params);});